import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

export default function NotFound() {
  return (
    <div className="flex min-h-[calc(100vh-theme(spacing.16))] flex-col items-center justify-center gap-4 px-4 py-8 text-center md:px-6 lg:py-16">
      <div className="space-y-2">
        <h1 className="text-6xl font-bold tracking-tighter sm:text-7xl md:text-8xl">404</h1>
        <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">Page Not Found</h2>
        <p className="max-w-[600px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          {"The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."}
        </p>
      </div>
      <Link to="/">
        <Button className="mt-4">Go to Homepage</Button>
      </Link>
    </div>
  )
}
